import { FC, ReactElement, memo } from 'react';
import './style.scss';

interface IProps {
  productError: string | undefined;
}

export const OrderCartProductErrorMessage: FC<IProps> = memo(({ productError }: IProps): ReactElement | null => {
  if (!productError) return null;

  return <p className="order-cart-product-error-message letter-spacing-12">{productError}</p>;
});
